import { render, staticRenderFns } from "./MiniProgramsElement.vue?vue&type=template&id=bfc321ae"
import script from "./MiniProgramsElement.vue?vue&type=script&lang=js"
export * from "./MiniProgramsElement.vue?vue&type=script&lang=js"
import style0 from "./MiniProgramsElement.vue?vue&type=style&index=0&id=bfc321ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports